"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inChars = void 0;
var parser_1 = require("@masala/parser");
function inChars(strings) {
    return parser_1.F.satisfy(function (value) {
        for (var i = 0; i < strings.length; i++) {
            var s = strings[i];
            if (s.length === 3 && s[1] === '-') {
                if (s[0] <= value && value <= s[2]) {
                    return true;
                }
            }
            else {
                if (s.includes(value)) {
                    return true;
                }
            }
        }
        return false;
    });
}
exports.inChars = inChars;
//# sourceMappingURL=in-chars.js.map